import { createContext } from "react";
import { FeedContextValue } from "./types";

export const FeedContext = createContext<FeedContextValue | undefined>(
  undefined
);
